import { RemoteGetQuestionOptionById } from 'data/usecases';
import { makeApiUrlEvaluationCriteriaQuestionOptions } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteGetQuestionOptionById =
  (): RemoteGetQuestionOptionById => {
    return new RemoteGetQuestionOptionById(
      makeApiUrlEvaluationCriteriaQuestionOptions(),
      makeAxiosHttpClient(),
    );
  };
